import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddTenantEmailDomainMutationVariables = Types.Exact<{
  input: Types.AddTenantEmailDomainInput;
}>;


export type AddTenantEmailDomainMutation = { __typename?: 'Mutation', addTenantEmailDomain: { __typename?: 'TenantEmailDomainPayload', domain?: { __typename?: 'TenantEmailDomainData', domain: string, status: Types.EmailSenderVerificationStatus, sendGridDomainId: string, origin: Types.EmailDomainOrigin, boundAt: Types.TDateISO, updatedAt: Types.TDateISO, challengeTxtHost?: string | null, challengeTxtRecord?: string | null, dnsRecords?: Array<{ __typename?: 'TenantEmailDomainDnsRecord', host: string, type: string, data: string, valid: boolean }> | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ValidateTenantEmailDomainMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ValidateTenantEmailDomainMutation = { __typename?: 'Mutation', validateTenantEmailDomain: { __typename?: 'TenantEmailDomainPayload', domain?: { __typename?: 'TenantEmailDomainData', domain: string, status: Types.EmailSenderVerificationStatus, sendGridDomainId: string, origin: Types.EmailDomainOrigin, boundAt: Types.TDateISO, updatedAt: Types.TDateISO, challengeTxtHost?: string | null, challengeTxtRecord?: string | null, dnsRecords?: Array<{ __typename?: 'TenantEmailDomainDnsRecord', host: string, type: string, data: string, valid: boolean }> | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveTenantEmailDomainMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type RemoveTenantEmailDomainMutation = { __typename?: 'Mutation', removeTenantEmailDomain: { __typename?: 'TenantEmailDomainPayload', domain?: { __typename?: 'TenantEmailDomainData', domain: string, status: Types.EmailSenderVerificationStatus, sendGridDomainId: string, origin: Types.EmailDomainOrigin, boundAt: Types.TDateISO, updatedAt: Types.TDateISO, challengeTxtHost?: string | null, challengeTxtRecord?: string | null, dnsRecords?: Array<{ __typename?: 'TenantEmailDomainDnsRecord', host: string, type: string, data: string, valid: boolean }> | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddTenantEmailDomainDocument = new TypedDocumentString(`
    mutation AddTenantEmailDomain($input: AddTenantEmailDomainInput!) {
  addTenantEmailDomain(input: $input) {
    domain {
      ...TenantEmailDomain
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailDomain on TenantEmailDomainData {
  domain
  status
  sendGridDomainId
  origin
  boundAt
  updatedAt
  challengeTxtHost
  challengeTxtRecord
  dnsRecords {
    host
    type
    data
    valid
  }
}`);
export const ValidateTenantEmailDomainDocument = new TypedDocumentString(`
    mutation ValidateTenantEmailDomain {
  validateTenantEmailDomain {
    domain {
      ...TenantEmailDomain
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailDomain on TenantEmailDomainData {
  domain
  status
  sendGridDomainId
  origin
  boundAt
  updatedAt
  challengeTxtHost
  challengeTxtRecord
  dnsRecords {
    host
    type
    data
    valid
  }
}`);
export const RemoveTenantEmailDomainDocument = new TypedDocumentString(`
    mutation RemoveTenantEmailDomain {
  removeTenantEmailDomain {
    domain {
      ...TenantEmailDomain
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailDomain on TenantEmailDomainData {
  domain
  status
  sendGridDomainId
  origin
  boundAt
  updatedAt
  challengeTxtHost
  challengeTxtRecord
  dnsRecords {
    host
    type
    data
    valid
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddTenantEmailDomain: build.mutation<AddTenantEmailDomainMutation, AddTenantEmailDomainMutationVariables>({
      query: (variables) => ({ document: AddTenantEmailDomainDocument, variables })
    }),
    ValidateTenantEmailDomain: build.mutation<ValidateTenantEmailDomainMutation, ValidateTenantEmailDomainMutationVariables | void>({
      query: (variables) => ({ document: ValidateTenantEmailDomainDocument, variables })
    }),
    RemoveTenantEmailDomain: build.mutation<RemoveTenantEmailDomainMutation, RemoveTenantEmailDomainMutationVariables | void>({
      query: (variables) => ({ document: RemoveTenantEmailDomainDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddTenantEmailDomainMutation, useValidateTenantEmailDomainMutation, useRemoveTenantEmailDomainMutation } = injectedRtkApi;
